export const AssetEN = {
    "asset": {
        "header": {
            "title": "Assets",
            "titleAdd": "Create Asset",
            "titleUpdate": "Update Asset"
        },
        "columns": {
            "code": "Code",
            "name": "Name",
            "category": "Category",
            "buyDate": "Buy date",
            "state": "State",
            "status": "Status",
            "propertyValues": "Properties",
            "priceInit": "Price Init",
            "store": "Store"
        },
        "title" : "Asset Store",
        "hanover" :{
            "title-list": "Distribution list",
            "titleAdd": "Add new allocation",
            "titleEdit": "Editing the distribution ticket",
            "titleDetail": "Details of the issuance slip",
            "col": {
                "code": "Issuance code",
                "asset": "Asset",
                "checkdepartment": "Departments are allocated",
                "department": "Receiving department",
                "employeeIdRecipient": "Receiver",
                "employeeIdRecipient1": "Receipt of Representative",
                "amount": "Amount",
                "inventory": "Inventory",
                "day": "Date Range",
                "hour": "Level time",
                "position": "Property location",
                "status": "Status",
                "addressLocation": "Delivery location",
                "deposit": "Deposit",
                "reasonHanover": "Issuance reason"
            },
            "placeholder": {
                "asset": "Choose property",
                "position": "Choose property location",
                "status": "Select status"
            },
            "status": {
                "using": "Using",
                "repair": "Repair and warranty",
                "liquidation": "Liquidation",
                "broken": "Broken",
                "away": "Pass away",
                "cancel": "Cancel"
            },
            "columns": {
                "department": "Departments are allocated",
                "individual": "Individual",
                "asset" : "Code TS",
                "asset-name" : "Asset",
                "day" : "Issuance date",
                "amount" : "Amount",
                "amount-invoke" : "Withdrawn",
                "check-department" : "Allotment to",
                "employee-recipient" : "Recipients",
                "department-recipient" : "Department",
                "position" : "Property location"
            },
            "tab": {
                "hanover": "Distributing",
                "invoke" : "Withdrawal",
                "invoke-success" : "Withdrawal done"
            }
        },
        "tab":{
            "detail" : "Detail",
            "information" : "General information",
            "history" : "Recovery history"
        },
        "modal-active":{
            "delete" : "Are you sure you want to delete?"
        },
        "action": {
            "cancel": "Cancellation notice",
            "broken": "Report broken",
            "repair": "Warranty repairs",
            "liquidation": "Liquidation",
            "loss": "Report lost",
            "increase": "Newspaper increase",
            "columns": {
                "date": "Day",
                "action": "Action",
                "quantityBegin": "Survive head",
                "quantity": "Amount",
                "quantityAfter": "Ending stocks",
                "price": "Amount of money",
                "description": "Describe"
            }
        }
    },
    "assetAction": {
        "header": {
            "title": "History of issuing and withdrawing",
            "title-store": "Inventory history"
        },
        "columns": {
            "actionDate": "Day",
            "code": "Code",
            "actionType": "Act",
            "quantity": "Amount",
            "creator": "Executor",
            "handoverFor": "Handed over to",
            "employeeRecipient": "Individual / Representative",
            "departmentRecipient": "Department",
            "assetEmployee": "Personal property",
            "assetDepartment": "Departmental assets"
        },
    },
    "asset-deduct" : {
        "code" : "Asset Code",
        "name" : "Asset Name",
        "groundName" : "Asset Group",
        "day" : "Depreciation start date",
        "amount" : "Amount",
        "price" : "Price",
        "totalPrice" : "Total amount",
        "periodDepreciated" : "Depreciation",
        "depreciated" : "Deducted",
        "remain" : "Remaining",

    }
}